import styled from 'styled-components';

export const Container = styled.div`
    color: #f00;
    padding: 20px;
`;

export const Section = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 10px;
`;

export const DrawOptions = styled.div`
    width: 390px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-conten: flex-start;
    flex-wrap: wrap;
`;

export const VerticalSpace = styled.div`
    height: 30px;
`;

export const EmptySpace = styled.div`
    height: 30px;
    width: 12px;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        width: 1px;
        top: 0;
        bottom: 0;
        left: 50%;
        border-left: 1px solid #444;
    }
`;

export const Label = styled.div`
    color: #999;
    font-size: 10px;
    text-transform: uppercase;
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    color: #fff;
    margin-bottom: 5px;
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
`;

export const Button = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #aaa;
    height: 30px;
    width: 30px;
    background-color: #000;
    margin-right: -1px;
    border: 1px solid #666;
    padding-left: 30px;
    box-sizing: border-box;
    position: relative;
    transition: all .4s ease 0s;
    cursor: pointer;

    :hover {
        border-color: #fff;
        color: #fff;
        z-index: 2;
    }

    &.selected {
        border-color: #ddd;
        color:  #666;
        background-color: #ddd;
        z-index: 1;
    }

    :before {
        position: absolute;
        top: -1px;
        left: 0;
        width: 30px;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        content: '${props => props.icon}';
        font-family: "Material Design Icons";
    }
`;

export const TokenSelector = styled.select`
    margin-top: 10px;
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    width: 100%;
    margin-bottom: 10px;
    color: #999;

`;

export const TextInput = styled.input`
    margin-top: 10px;
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    width: 100%;
    margin-bottom: 10px;
    color: #999;
`;

export const TabGrou = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    border-bottom: 1px solid #555;
    margin-bottom: 10px;
`;

export const Tab = styled.div`
    padding: 2px 10px;
    border: 1px solid #333;
    font-size: 12px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #999;
    background-color: #333;
    margin-right: 1px;
    position: relative;
    z-index: 1;

    &.selected {
        z-index: 3;
        color: #fff;
        background-color: #444;
        border: 1px solid #444;
    }
`;

export const TabContent = styled.div`
    &.hidden {
        display: none;
    }
`;